module.exports = __webpack_public_path__ + "img/car2.def7ccb7.png";